import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { reduxForm, Field, change, formValueSelector, PropTypes as formProps, unregisterField, registerField } from 'redux-form';
import { Toggle } from '@zola/zola-ui'; // eslint-disable-line
import { RenderField } from '../../../../../common/form';
import * as Validations from '../../../../../common/form/commonValidations';
import { updateWeddingAccount } from '../../../../../../actions/WeddingActions';
import { updateUserStatus } from '../../../../../../actions/UserActions';
import * as NotificationService from '../../../../../../actions/NotificationActions';
import './PasswordSettingsForm.styles.less';

// Disable  camelcase rule for file to allow for snake case elements from reducer.
/* eslint  camelcase: 0 */

class PasswordSettingsForm extends React.Component {
  handlePasscodeUpdate = (payload) => {
    const { showSuccessNotification, showErrorNotification, onUpdatePasscodeSettings, handleUpdateUserStatus } = this.props;
    const successMessage = 'Your password settings have been saved!';
    const errorMessage = 'There was a problem updating your settings.';

    handleUpdateUserStatus().then((userStatus) => {
      if (userStatus.payload.status !== 'IDLE') {
        onUpdatePasscodeSettings(payload)
          .then(showSuccessNotification(successMessage)).catch(() => showErrorNotification(errorMessage));
      } else {
        browserHistory.push({ pathname: '/wedding/login', state: { referralPage: window.location.pathname } });
      }
    });
  }

  handleUpdatePasscodeSettings = (formValues) => {
    const enable_passcode = JSON.parse(formValues.hasPasscode);
    const passcode = enable_passcode ? formValues.passcode : null;
    const passcode_instructions = enable_passcode ? formValues.guestInstructions || null : null;
    const weddingAccountRequest = Object.assign({}, this.props.account, { passcode, passcode_instructions, enable_passcode });

    this.handlePasscodeUpdate(weddingAccountRequest);
  }

  handleTogglePasscode = (passcode) => {
    const { onTogglePasscode, onRegisterPasswordField, onUnregisterPasswordField, account } = this.props;

    if (passcode) {
      const weddingAccountRequest = Object.assign({}, account, { passcode: null, passcode_instructions: null, enable_passcode: false });

      this.handlePasscodeUpdate(weddingAccountRequest);
      onRegisterPasswordField();
    } else {
      onUnregisterPasswordField();
    }
    onTogglePasscode(passcode);
  }

  render() {
    const { pristine, valid, submitting, handleSubmit, hasPasscode, initialValues } = this.props;
    const hasPristinePasscode = (typeof this.props.passcode) === 'undefined' || this.props.passcode === '';
    const isDisabled = pristine || !valid || submitting || (hasPristinePasscode && initialValues.hasPasscode === 'false' && hasPasscode === 'true');

    return (
      <form
        id="password-settings-form"
        className="mpr-password-settings-form"
        onSubmit={handleSubmit(this.handleUpdatePasscodeSettings)}
      >
        <div className="passcode-input">
          <div className="passcode-heading">
            <span>Password Protect Website</span>
          </div>
          <div className="padding-top margin-bottom passcode-toggle">
            <Field
              name="hasPasscode"
              component={props => <Toggle {...props} input={{ value: JSON.parse(props.input.value), onChange: props.input.onChange }} withIcons />}
              onChange={() => this.handleTogglePasscode(JSON.parse(hasPasscode))}
            />
          </div>
        </div>
        <div className={(hasPasscode === 'true' || hasPasscode === true) ? '' : 'hidden'}>
          <div className="padding-top">
            <div className="title">
              <span>Password <span className="text-danger danger-asterisk">*</span></span>
            </div>
            <div className="mpr-passcode-group">
              <Field
                className="input-field passcode-input-field"
                type="text"
                component={RenderField}
                name="passcode"
                id="passcode"
                placeholder="Password"
                validate={hasPasscode === 'true' || hasPasscode === true ? [Validations.REQUIRED, Validations.MAX_LENGTH_20] : []}
                maxChars={20}
              />
              <span>
                <button type="submit" className="text-button margin-top mpr-passcode__btn" disabled={isDisabled}>Save</button>
              </span>
            </div>
          </div>
          <div className="padding-top">
            <div className="title">
              <span>Note for Retrieving Password</span>
            </div>
            <Field
              className="input-field"
              hideFormGroup
              type="text"
              component={RenderField}
              name="guestInstructions"
              placeholder="Check the back of your invitation"
              id="passcode-note"
            />
          </div>
        </div>
        <div className="passcode-account-settings">
          <a href="/account/settings/privacy" className="account-settings">All Privacy Settings ›</a>
        </div>
      </form>
    );
  }
}

PasswordSettingsForm.propTypes = {
  passcode: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  hasPasscode: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  onTogglePasscode: PropTypes.func, // eslint-disable-line
  onUpdatePasscodeSettings: PropTypes.func,
  showErrorNotification: PropTypes.func,
  showSuccessNotification: PropTypes.func,
  onUnregisterPasswordField: PropTypes.func, // eslint-disable-line
  onRegisterPasswordField: PropTypes.func, // eslint-disable-line
  handleUpdateUserStatus: PropTypes.func,
  ...formProps
};

const selector = formValueSelector('passwordSettingsForm');

const mapStateToProps = (state) => {
  const { account } = state.wedding;
  const { passcode, passcode_instructions } = account;
  let { enable_passcode } = account;
  // Check must be performed to prevent errors during initial renders before the store fetches account state.
  if (!enable_passcode) {
    enable_passcode = false;
  }
  return ({
    passcode: selector(state, 'passcode'),
    hasPasscode: selector(state, 'hasPasscode'),
    initialValues: {
      hasPasscode: enable_passcode.toString(),
      passcode,
      guestInstructions: passcode_instructions
    },
    account: state.wedding.account,
  });
};

const mapDispatchToProps = dispatch => ({
  onTogglePasscode: isEnabled => dispatch(change('passwordSettingsForm', 'hasPasscode', isEnabled)),
  onUpdatePasscodeSettings: request => dispatch(updateWeddingAccount(request)),
  showSuccessNotification: message => dispatch(NotificationService.confirmation({ message })),
  showErrorNotification: message => dispatch(NotificationService.error({ message })),
  onRegisterPasswordField: () => dispatch(registerField('passwordSettingsForm', 'passcode', 'Field')),
  onUnregisterPasswordField: () => dispatch(unregisterField('passwordSettingsForm', 'passcode')),
  handleUpdateUserStatus: () => dispatch(updateUserStatus())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm({
  form: 'passwordSettingsForm',
  enableReinitialize: true
})(PasswordSettingsForm));



// WEBPACK FOOTER //
// ./src/components/manage/website/ManagePagesRedesign/DropDownForms/PasswordSettingsForm/PasswordSettingsForm.jsx